/**
 * EmailTemplateSection.tsx
 * メールテンプレート送信ボタン群（フリー / リクエスト系 / コメント返信）
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';

interface EmailTemplateSectionProps extends SectionProps {
  onOpenEmailTemplate?: (type: string) => void;
}

const EMAIL_TEMPLATES = [
  { type: 'payment', label: '決済御礼' },
  { type: 'free', label: 'フリー' },
  { type: 'request_ok', label: 'リクエスト OK' },
  { type: 'request_full', label: 'リクエスト full' },
  { type: 'request_offer', label: 'リクエスト offer' },
  { type: 'comment', label: 'comment' },
] as const;

export default function EmailTemplateSection({
  disabled,
  isNew,
  onOpenEmailTemplate,
}: EmailTemplateSectionProps) {
  if (isNew || !onOpenEmailTemplate) return null;

  return (
    <>
      <SectionHeader title="メールテンプレート" />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '8px 4px' }}>
        {EMAIL_TEMPLATES.map((tpl) => (
          <button
            key={tpl.type}
            type="button"
            onClick={() => onOpenEmailTemplate(tpl.type)}
            disabled={disabled}
            style={{
              padding: '4px 12px',
              fontSize: '0.75rem',
              border: 'none',
              borderRadius: 4,
              background: '#475569',
              color: '#fff',
              cursor: disabled ? 'default' : 'pointer',
            }}
          >
            {tpl.label}
          </button>
        ))}
      </div>
    </>
  );
}
